import '@app/App.css';
import HomeHeader from '@app/HomeHeader';
import { TW_App } from '@utils/twClasses';
import { useEffect, useMemo } from 'react';
import { useAppStore } from 'src/store';
import UsersSection from './UsersSection';
import { DEFAULT_COMPOZZ_COLOR, applyBrightness, getLightColor } from '@utils/colors';

function UsersManagement() {

  const fetchUsers = useAppStore(state => state.fetchUsers);
  const fetchTenant = useAppStore(state => state.fetchTenant);
  const tenant = useAppStore(state => state.tenant);
  const defaultColor = useMemo(() => tenant?.customColor ?? DEFAULT_COMPOZZ_COLOR, [tenant?.customColor]);
  const defaultDarkColor = useMemo(() => applyBrightness(defaultColor, -25), [defaultColor]);
  const defaultLightColor = useMemo(() => getLightColor(defaultColor), [defaultColor]);
  
  useEffect(() => {
    fetchUsers();
    fetchTenant();
  }, []);


  const scrollbarStyle: React.CSSProperties = useMemo<React.CSSProperties>(() => ({
    scrollbarColor: `${defaultDarkColor} ${defaultLightColor}`,
  }), [defaultDarkColor, defaultLightColor]);
  return (
    <div className={TW_App} style={scrollbarStyle}>
      <HomeHeader />
      <UsersSection />
    </div>
  );
};

export default UsersManagement;